import React from 'react';
import { motion } from 'framer-motion';

const LoadingScreen = () => {
  return (
    <div className="fixed inset-0 bg-background flex items-center justify-center z-[100]">
      <div className="text-center">
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          className="relative w-24 h-24 mb-8 mx-auto"
        >
          {/* Inner Circle */}
          <motion.div 
            className="absolute inset-0 border-2 border-primary/20 rounded-full"
          />
          {/* Rotating Spinner */}
          <motion.div 
            className="absolute inset-0 border-t-2 border-primary rounded-full"
            animate={{ rotate: 360 }}
            transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
          />
          {/* Core Dot */}
          <div className="absolute inset-[40%] bg-primary rounded-full blur-[4px] animate-pulse" />
        </motion.div>
        
        <motion.h1
          className="text-2xl font-bold tracking-[0.4em] text-white uppercase"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          RAVINDU
        </motion.h1>
        
        <motion.div 
          className="h-[1px] bg-gradient-to-r from-transparent via-white/20 to-transparent w-48 mx-auto mt-4"
          initial={{ scaleX: 0 }}
          animate={{ scaleX: 1 }}
          transition={{ duration: 1, delay: 0.5 }}
        />
      </div>
    </div>
  );
};

export default LoadingScreen;

